<template>
  <Block title="制度与流程索引" class="iv-m-t-24" style="width: 384px;height: 336px;" @on-more="toMorePage">
    <ul class="iv-institutional-index iv-p-t-8" v-if="list.length > 0">
      <li class="iv-institutional-index-li iv-pull-left iv-m-t-20 iv-fc-65" v-for="item in list" :key="item.categoryId" @click="todetail(item)">
        <p>{{item.categoryName}}</p>
      </li>
    </ul>
    <NoData v-if="list.length <= 0"></NoData>
  </Block>
</template>

<script>
import Block from '@/components/block'
import NoData from '@/components/no-data'
import IconFont from '@/components/iconfont'
// import {titleConfig} from './index-config.js'

export default {
  name: 'institutionalIndex',
  data () {
    return {
      list: []
    }
  },
  created () {
    this.$ajax({
      url: 'api-qixuan/infoPublish/category/byCode/list',
      method: 'get',
      data: {
        code: 'system_index'
      }
    }).then(({data}) => {
      this.list = data.data
    })
  },
  methods: {
    //点击更多
    toMorePage () {
      const { href } = this.$router.resolve({
        name: 'systemIndex',
        query: {
          categoryType: 1,
          categoryCode: 'system_index',
          categoryName: '制度与流程索引'
        }
      })
      window.open(href, '_blank')
    },
    todetail (item) {
      const { href } = this.$router.resolve({
        name: 'systemIndex',
        query: {
          categoryType: item.categoryType,
          categoryCode: 'system_index',
          subCategoryCode: item.categoryCode,
          categoryId: item.categoryId,
          categoryName: item.categoryName
        }
      })
      window.open(href, '_blank')
    }
  },
  components: {
    Block,
    NoData,
    IconFont
  }
}
</script>

<style lang="scss" scoped>
.iv-institutional-index {
  background: #fff;
  overflow: hidden;
  .iv-institutional-index-li {
    float: left;
    width: 162px;
    height: 102px;
    border-radius: 8px;
    margin-top: 20px !important;
    cursor: pointer;
    background: url('~@/assets/images/index/ins-bg.png') no-repeat center center;
    margin-right: 20px;
    &:nth-child(2n) {
      margin-right: 0px;
    }
    &:nth-child(3) {
      margin-top: 20px !important;
      margin-bottom: 28px;
    }
    &:nth-child(4) {
      margin-top: 20px !important;
      margin-bottom: 28px;
    }
    p {
      margin: 20px 0 0 20px;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.65);
    }
  }
}
</style>
